import type { Tier } from "./types";
import tierData from "../data/tiers.json";

export const TIERS: readonly Tier[] = tierData as Tier[];

export const MAX_TIER = TIERS.reduce((m, t) => Math.max(m, t.level), 0);

/** Points indexed by tier level (index 0 unused). */
export const TIER_POINTS: number[] = (() => {
  const arr = new Array<number>(MAX_TIER + 1).fill(0);
  for (const t of TIERS) arr[t.level] = t.points;
  return arr;
})();

const BY_LEVEL = new Map<number, Tier>(TIERS.map((t) => [t.level, t]));

export function tier(level: number): Tier {
  const t = BY_LEVEL.get(level);
  if (!t) throw new Error(`Unknown tier level: ${level}`);
  return t;
}
